import React, { useState } from 'react'
import NurseryDetailList from './NurseryDetailList'
import NurseryDetailForm from './NurseryDetailForm';

const NurseryDetail= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <NurseryDetailForm addForm={setFromIsShown} update={upData}  sId={serviceId}/>
        ) : (
          <NurseryDetailList addForm={setFromIsShown} update={setUpData} sId={setServiceId} />
        )}
  
    </>
  )
}

export default NurseryDetail